<template>
  <vue-office-docx
    v-if="docType == 'word'"
    :src="docUrl"
    style="height: 100vh"
    @rendered="rendered"
  />
  <vue-office-excel
    v-else
    :src="docUrl"
    style="height: 100vh"
    @rendered="rendered"
  />
</template>
<script>
//引入VueOfficeDocx组件
import VueOfficeDocx from "@vue-office/docx";
import VueOfficeExcel from "@vue-office/excel";
//引入相关样式
import "@vue-office/docx/lib/index.css";

export default {
  name: "preview",
  components: {
    VueOfficeDocx,
    VueOfficeExcel,
  },
  data() {
    return {
      docUrl: "",
      docType: "",
    };
  },
  computed: {},
  mounted() {
    let url = this.$route.query.url;
    this.docUrl = url;
    this.docType = this.getFileType(url);
  },
  methods: {
    rendered() {
      console.log("渲染完成");
    },
    getFileType(url) {
      let fileName = url.split("/").pop();
      let suffix = "";
      // 获取类型结果
      let result = "";
      try {
        const flieArr = fileName.split("."); //根据.分割数组
        suffix = flieArr[flieArr.length - 1]; //取最后一个
      } catch (err) {
        //如果fileName为空等.split方法会报错，就走下面的逻辑
        suffix = "";
      }
      // fileName无后缀返回 false
      if (!suffix) {
        //走catch后返回false
        return "unknown";
      }
      suffix = suffix.toLocaleLowerCase(); //将后缀所有字母改为小写方便操作

      // 图片格式
      const imglist = ["png", "jpg", "jpeg", "bmp", "gif", "webp", "jfif"]; //可以将符合该分类的后缀都写入数组里
      // 进行图片匹配
      result = imglist.find((item) => item === suffix);
      if (result) {
        return "image";
      }
      // 匹配txt
      const txtlist = ["txt"];
      result = txtlist.find((item) => item === suffix);
      if (result) {
        return "txt";
      }
      // 匹配 excel
      const excelist = ["xls", "xlsx"];
      result = excelist.find((item) => item === suffix);
      if (result) {
        return "excel";
      }
      // 匹配 word
      const wordlist = ["doc", "docx"];
      result = wordlist.find((item) => item === suffix);
      if (result) {
        return "word";
      }
      // 匹配 pdf
      const pdflist = ["pdf"];
      result = pdflist.find((item) => item === suffix);
      if (result) {
        return "pdf";
      }
      // 匹配 ppt
      const pptlist = ["ppt", "pptx"];
      result = pptlist.find((item) => item === suffix);
      if (result) {
        return "ppt";
      }
      // 匹配 视频
      const videolist = [
        "mp4",
        "m2v",
        "mkv",
        "rmvb",
        "wmv",
        "avi",
        "flv",
        "mov",
        "m4v",
      ];
      result = videolist.find((item) => item === suffix);
      if (result) {
        return "video";
      }
      // 匹配 音频
      const radiolist = ["mp3", "wav", "wmv"];
      result = radiolist.find((item) => item === suffix);
      if (result) {
        return "radio";
      }
      // 匹配 压缩包
      const ziplist = ["zip", "rar"];
      result = ziplist.find((item) => item === suffix);
      if (result) {
        return "zip";
      }
      return "unknown"; //以上的判断逻辑都没return时反馈当前后缀是其他类型文件后缀
    },
  },
};
</script>

<style scoped>
.viewWarp {
  height: 100vh;
  overflow: auto;
  width: 100%;
  padding: 1.25rem;
  box-sizing: border-box;
}
</style>
